import { Injectable, OnDestroy } from '@angular/core';
import { Auth, User, authState } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RSFirebaseService implements OnDestroy {
  private auth: Auth;
  authState$: Observable<User | null>;
  authStateSubscription: Subscription;
  loggedIn = false
  currentUser?: User

  constructor(
    auth: Auth,
    private router: Router
  ) {
    this.auth = auth;
    this.authState$ = authState(this.auth);
    this.authStateSubscription = this.authState$.subscribe((aUser: User | null) => {
      // Handle auth state changes here. Note that user will be null if there is no currently logged in user.
      console.log("Auth state changed ", aUser)
      if(aUser && aUser.uid){
        this.loggedIn = true
        this.currentUser = aUser
      } else {
        this.loggedIn = false
        this.currentUser = undefined
        this.router.navigateByUrl("/")
      }
    });
  }

  async getCurrentUser(): Promise<User | null> {
    try {
      const user = this.auth.currentUser;
      return user;
    } catch (err) {
      console.error('Error getting current user', err);
      return null;
    }
  }

  async getIdtoken(): Promise<string | null> {
    try {
      const user = this.auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        // console.log(token)
        return token;
      }
      return null;
    } catch (err) {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }
  }
}
